import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function fetchTutorial(id: string) {
  const { data } = await unauthenticatedHttp()
    .get(`${globalThis.env.API_UNAUTH}/courses/${id}`)
    .catch((error) => {
      return error.response.data;
    });

  return data;
}
